import { GET, POST } from "../../utils/constants/verbs";
import { put, takeLatest } from "redux-saga/effects";
import requestAPI from "../../helpers/requestHelpers";
import { Types } from "../ducks/school";
import urls from "../../utils/constants/urlsAPI";

function* requestCoutries() {
  try {
    const { soccer_schools } = yield requestAPI({
      verb: GET,
      endPoint: urls.listSoccerSchools
    });
    yield put({
      type: Types.SCHOOL_REQUEST_SUCCESS,
      schools: soccer_schools
    });
  } catch (e) {}
}

function* registerSchool({ payload }) {
  try {
    const response = yield requestAPI({
      verb: POST,
      endPoint: urls.sendEmail,
      data: payload
    });
    yield put({
      type: Types.SCHOOL_REGISTER_SUCCESS,
      message: response.message
    });
  } catch (e) {
    yield put({
      type: Types.SCHOOL_REGISTER_FAIL
    });
  }
}

export function* watcherSaga() {
  yield takeLatest(Types.SCHOOL_REQUEST, requestCoutries);
  yield takeLatest(Types.SCHOOL_REGISTER_REQUEST, registerSchool);
}
